import { useCookies } from "react-cookie";
import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { logOut } from "@/services/API/Authorization";

import "./NavigationMenu.scss";

export default function NavigationMenu() {
    const [cookies, , removeCookie] = useCookies([
        "letters",
        "username",
        "jwt",
        "role",
        "email",
        "isAuthorized",
    ]);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    async function removeCookies() {
        const result = await logOut();

        if (result.status === 200) {
            removeCookie("letters", { path: "/" });
            removeCookie("username", { path: "/" });
            removeCookie("jwt", { path: "/" });
            removeCookie("isAuthorized", { path: "/" });
            removeCookie("email", { path: "/" });
            removeCookie("role", { path: "/" });
            if (cookies.role) {
                removeCookie("role", { path: "/" });
            }
        }
    }

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                <Tooltip title='Профіль користувача'>
                    <IconButton
                        onClick={handleClick}
                        size='small'
                        sx={{ ml: 2 }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup='true'
                        aria-expanded={open ? "true" : undefined}
                    >
                        <Avatar
                            sx={{
                                width: 48,
                                height: 48,
                                backgroundColor: "#109439",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.15)",
                                },
                            }}
                        >
                            {cookies.letters ? cookies.letters : null}
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id='account-menu'
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            minWidth: 256,
                            height: "112px",
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: "-40px",
                            ml: "66px",
                        },
                    },
                    list: {
                        sx: {
                            height: "112px",
                            padding: 0,
                            overflow: "auto",
                        },
                    },
                }}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
                <ul className='avatar_nav_list'>
                    {cookies.letters && cookies.username ? (
                        <li className='nav_li'>
                            <div className='logo_container'>
                                {cookies.letters}
                            </div>
                            <div className='nav_li_user_info_container'>
                                <p>{cookies.username}</p>
                                <p>{cookies.email}</p>
                            </div>
                            <img
                                className='avatar_nav_arrow'
                                src='/navigation/arrow-right.svg'
                                alt='logo arrow right'
                            />
                        </li>
                    ) : null}

                    <li className='nav_li' onClick={() => removeCookies()}>
                        <p>Вийти</p>
                        <img
                            className='avatar_nav_arrow'
                            src='/navigation/arrow-right.svg'
                            alt='logo arrow right'
                        />
                    </li>
                </ul>
            </Menu>
        </React.Fragment>
    );
}
